import React from 'react';
import { PropTypes } from 'prop-types';

import StepNavigation from '../StepNavigation';
import WorkshopProcessSlide from './WorkshopProcessSlide';
import NextSlideButton from '../NextSlideButton';

import CarouselNavigationButtons, { ButtonTypes } from '../CarouselNavigationButtons';

const WorkshopProcessContent = ({
    styles,
    rules,
    type,
    slides,
    activeIndex,
    moveToNextSlide,
    width,
    isMoving,
    transitionDuration,
    moveToNextSlideMobile,
    handleHover,
    moveToSlideId,
}) => {
    const handleMobileNextSlide = React.useCallback(
        e => {
            e.stopPropagation();
            moveToNextSlideMobile();
        },
        [moveToNextSlideMobile],
    );

    return (
        <>
            <StepNavigation
                isLarge
                type={type}
                slides={slides}
                currentSlide={activeIndex}
                nextSlide={moveToNextSlide}
                handleHover={handleHover}
                moveToSlideId={moveToSlideId}
                extend={{ container: rules.extendNavigationContainer }}
            />
            <div className={styles.container}>
                {slides.map((slide, index) => (
                    <WorkshopProcessSlide
                        title={slide.title}
                        description={slide.description}
                        linkType={slide.linkType}
                        link={slide.link}
                        linkEN={slide.linkEN || null}
                        key={slide.id}
                        width={width}
                        isMoving={isMoving}
                        transitionDuration={transitionDuration}
                        reference={slide.reference}
                        mainImage={slide.mainImage}
                        mainImageAlt={slide.mainImageAlt}
                        moveToNextSlide={moveToNextSlide}
                        moveToNextSlideMobile={moveToNextSlideMobile}
                        isActive={activeIndex === index}
                        handleHover={handleHover}
                    />
                ))}
            </div>

            <CarouselNavigationButtons
                {...{
                    moveToSlideId,
                    activeIndex,
                    type: ButtonTypes.LIGHT,
                    extend: {
                        navigationContainer: rules.navigationContainer,
                        navigationButton: rules.navigationButton,
                    },
                }}
            />

            <NextSlideButton extend={rules.extendNextButton} onClick={handleMobileNextSlide} />
        </>
    );
};

WorkshopProcessContent.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    type: PropTypes.string.isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    isMoving: PropTypes.bool.isRequired,
    transitionDuration: PropTypes.number.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    handleHover: PropTypes.func,
    moveToSlideId: PropTypes.func,
};

WorkshopProcessContent.defaultProps = {
    handleHover: null,
    moveToSlideId: null,
};

export default WorkshopProcessContent;
